<template>
  <Catalogs
    title="Типы расходов исполнителя"
    create-text="Новый"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'WorkerCostTypeAdd'"
    :route-edit="'WorkerCostTypeEdit'"
    :route-view="'WorkerCostTypeView'"
    :route-path="'/worker_cost_types'"
    :can-edit="canEditWorkerCostTypeCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
   import Catalogs from "../Catalogs.vue";

export default {
  name: "WorkerCostTypes",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'worker-cost-type-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'action',
          label: "Действия",
          class: 'worker-cost-type-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getWorkerCostTypes(data);
    },
    canEditWorkerCostTypeCatalogs() {
      return this.hasPermission([PERM.CATALOG_WORKER_COST_TYPE_EDIT]);
    }
  }
}
</script>

<style >
.worker-cost-type-id {
  width: 60px;
  text-align: center;
}

.worker-cost-type-action {
  width: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerCostTypes/WorkerCostTypes.vue